export const findFirstFocusableElement = (container: HTMLElement) => {
  return container.querySelector<HTMLElement>(
    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
  );
};
